import { render } from "./UserShow.vue?vue&type=template&id=cf868630"
import script from "./UserShow.vue?vue&type=script&lang=js"
export * from "./UserShow.vue?vue&type=script&lang=js"

import "./UserShow.vue?vue&type=style&index=0&id=cf868630&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__